<section id="about" class="about-section-modern py-5" appScrollReveal>
  <div class="container">
    <h2 class="section-title">About the Doctor</h2>
    <div class="about-grid">
      <div class="about-text">
        <header class="mb-3">
          <h3 class="display-name h4 fw-bold mb-2">Dr. Pragyan Kumar Routray</h3>
          <p class="role text-muted mb-2">Senior Internal Medicine & Critical Care Physician</p>
        </header>
        <p>Dr. Pragyan Kumar Routray is an experienced physician specialising in Internal Medicine and Critical Care with over two decades of dedicated service. He is known for his compassionate approach, clear communication, and evidence-based treatment plans.</p>
        <p>He provides adult medical consultations, chronic disease management, post-hospital recovery guidance, and critical-care follow-ups.</p>
        <p>He also consults at CARE Hospitals, Bhubaneswar, alongside running his independent personal clinic — Shree Radha Clinic.</p>
        <div class="vision-box mt-4 p-4 rounded shadow-sm">
          <h4 class="h6 fw-semibold text-uppercase mb-2">Vision</h4>
          <p class="mb-0">To deliver advanced, ethical, and patient-centric medical care while ensuring every family receives clarity, support, and timely treatment — especially during critical medical situations.</p>
        </div>
      </div>
      <div class="about-side">
        <figure class="doctor-photo-wrapper m-0">
          <div class="doctor-photo-frame modern shadow-sm">
            <img src="assets/dr.-pragyan-kumar-routray.webp" alt="Portrait of Dr. Pragyan Kumar Routray" loading="lazy" decoding="async" />
          </div>
          <figcaption class="visually-hidden">Professional portrait</figcaption>
        </figure>
        <div class="qualifications-card mt-4 p-4 rounded shadow-sm bg-light">
          <h5 class="fw-semibold mb-3">Qualifications</h5>
          <ul class="qualifications-list list-unstyled small mb-3">
            <li>MBBS – SCB Medical College, Cuttack</li>
            <li>MD (Medicine) – SCB Medical College, Cuttack</li>
            <li>Diploma in Critical Care – Apollo Hospitals, Chennai</li>
            <li>European Diploma in Intensive Care (EDIC)</li>
            <li>AHA-Certified ACLS & BLS Instructor</li>
          </ul>
          <div class="languages small">
            <span class="fw-semibold d-block mb-1">Languages:</span>
            <span>Odia · English · Hindi</span>
          </div>
          <div class="registration small mt-3">
            <span class="fw-semibold d-block mb-1">Registration:</span>
            <span>Odisha Medical Council — Reg. No. to be updated</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
